var AppDispatcher = require('../core/AppDispatcher.jsx');
var ActionTypes = require('../constants/SelectCustomerConstants.js').ActionTypes;
var ClientsAPI = require('../apis/ClientsAPI.js');

module.exports = {
    updateClientSearch: function (searchValue) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_CLIENT_SEARCH,
            searchValue: searchValue
        })
    },

    validateClientSearch: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.VALIDATE_CLIENT_SEARCH
        })
    },

    clearClientSearch: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_CLIENT_SEARCH
        })
    },

    searchClient: function (query) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_SEARCH_STARTED
        })
        ClientsAPI.searchClient(query);
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ClientSearchActions.js